import axiosClients from './axiosClients';
import axiosEkyc from './axiosEkyc';
import axiosLog from './axiosLog';
import { axiosType } from '../../dataStore/memoryStore/const/constIndex';


const isCheckPWARequestByUrl = (url: string, pwa: boolean) => {
    let _url = new URL(url)
    if (pwa == false) {
        _url.searchParams.append("pwa", "false");
    } else {
        // Mặc định PWA
        _url.searchParams.append("pwa", "true");
    }
    return _url.href || url
}

export const get = (apiType: string, url: any, options: { cancelToken: any }, config: { pwa: boolean | false }) => {
    // url = isCheckPWARequestByUrl(url, config?.pwa)
    switch (apiType) {
        case axiosType.CLIENT:
            return axiosClients.get(url, options);
        case axiosType.EKYC:
            return axiosEkyc.get(url);
        case axiosType.LOG:
            return axiosLog.get(url);
        default:
            return axiosClients.get(url);
    }
}

export const post = (apiType: string, url: string, data: any, config: any) => {
    switch (apiType) {
        case axiosType.CLIENT:
            return axiosClients.post(url, data, config);
        case axiosType.EKYC:
            return axiosEkyc.post(url, data, config);
        case axiosType.LOG:
            return axiosLog.post(url, data, config);
        default:
            return axiosClients.post(url, data, config);
    }
}

export const deleteAxios = (apiType: string, url: string, config: any) => {
    switch (apiType) {
        case axiosType.CLIENT:
            return axiosClients.delete(url, config);
        case axiosType.EKYC:
            return axiosEkyc.delete(url, config);
        case axiosType.LOG:
            return axiosLog.delete(url, config);
        default:
            return axiosClients.delete(url, config);
    }
}

